import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "546",
  height: "480",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "#fff",
      opacity: ".05"
    }, [
      _createElementVNode("path", { d: "M391.158 415.874h-105.54c-4.524-.019-8.183-3.684-8.183-8.197V302.411c0-85.16 69.223-154.235 154.641-154.275h105.61c4.512.039 8.149 3.698 8.149 8.198v105.089c0 85.253-69.273 154.33-154.712 154.311M268.506 217.207v105.231c-.077 4.505-3.772 8.111-8.29 8.092H154.747C69.267 330.53 0 261.443 0 176.22V71.095c-.02-4.553 3.655-8.264 8.219-8.303h105.504c85.455 0 154.763 69.148 154.783 154.415M268.407 344.512V480h-11.252V344.512a5.62 5.62 0 0 1 2.676-5.243 5.65 5.65 0 0 1 5.899 0 5.62 5.62 0 0 1 2.677 5.243" }),
      _createElementVNode("path", { d: "M277.435 242.582V154.31C277.435 69.144 346.653.058 432.076 0h92.312c4.509.077 8.13 3.735 8.148 8.233V138.09H432.111c-65.362 0-128.08 36.941-154.676 104.491" })
    ], -1)
  ]))]))
}
export default { render: render }